module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', _vm._l((_vm.nodeData), function(item, index) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.hasOwnProperty('visible') || item.visible),
        expression: "!item.hasOwnProperty('visible') || item.visible"
      }],
      key: item.key
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.hasOwnProperty('dynamicAdd')),
        expression: "item.hasOwnProperty('dynamicAdd')"
      }],
      key: index
    }, [_c('input', {
      directives: [{
        name: "focus",
        rawName: "v-focus"
      }],
      key: item.key,
      ref: "inputadd",
      refInFor: true,
      staticClass: "add-input",
      attrs: {
        "type": "text",
        "value": ""
      },
      on: {
        "blur": function($event) {
          _vm.addNode(item, $event)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          _vm.addNode(item, $event)
        }
      }
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.hasOwnProperty('dynamicAdd')),
        expression: "!item.hasOwnProperty('dynamicAdd')"
      }],
      staticClass: "item-handle-area",
      class: {
        'node-selected': (item.checked && !_vm.options.showCheckbox) || item.searched
      },
      on: {
        "click": function($event) {
          _vm.handleNode(item)
        }
      }
    }, [(_vm.isLeaf(item)) ? _c('i', {
      staticClass: "icon iconfont  handle-icon",
      class: [item.open ? _vm.options.iconClass.open : _vm.options.iconClass.close],
      style: (_vm.options.iconStyle),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.handleNodeExpand(item, index)
        }
      }
    }) : _c('i', {
      staticClass: "icon iconfont ",
      class: _vm.leafIcon(item),
      style: (_vm.options.iconStyle)
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.options.showCheckbox),
        expression: "options.showCheckbox"
      }],
      staticClass: "inputCheck",
      class: {
        notAllNodes: item.nodeSelectNotAll
      },
      style: ({
        width: _vm.inputWidth + 'px',
        height: _vm.inputWidth + 'px',
        color: _vm.options.iconStyle.color
      }),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.walkCheckBox(item)
        }
      }
    }, [(_vm.options.showCheckbox && !item.nodeSelectNotAll) ? _c('input', {
      key: item.key,
      staticClass: "check",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": item.checked
      },
      on: {
        "change": function($event) {
          _vm.checkBoxChange(item, $event)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.loading),
        expression: "item.loading"
      }],
      staticClass: "halo-tree-icon_loading halo-tree-iconEle",
      style: (_vm.options.iconStyle)
    }), _vm._v(" "), _c('span', {
      staticClass: "label"
    }, [_vm._v("\n                " + _vm._s(item[_vm.options.labelKey]) + "\n            ")]), _vm._v(" "), (_vm.canAdd(item)) ? _c('i', {
      staticClass: "iconfont add-icon",
      class: _vm.options.iconClass.add,
      style: (_vm.options.iconStyle),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.handleClickAddNode(item, index)
        }
      }
    }) : _vm._e()]), _vm._v(" "), (item.children && item.children.length > 0) ? _c('vue2-tree-node', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.open),
        expression: "item.open"
      }],
      ref: "treenode",
      refInFor: true,
      attrs: {
        "options": _vm.options,
        "tree-data": item.children
      },
      on: {
        "handlecheckedChange": _vm.handlecheckedChange
      }
    }) : _vm._e()], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1679028f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tree/vue2-tree-node.vue
// module id = 1071
// module chunks = 159